const Sinistri = ({ data }) => {
  return <div>Sinistri</div>;
};

export default Sinistri;
